import { IBreadcrumbItem, IComboBoxStyles, IStackTokens, ITextFieldStyles, mergeStyleSets, mergeStyles } from "@fluentui/react";
import * as H from "history";

export interface ICountriesProfileProps {
  history?: H.History;
  onCountryProfile: (isCountryProfile: boolean) => void;
}

export interface ICountriesProfileDetailProps {
  history?: H.History;
  onCountryProfile: (isCountryProfile: boolean) => void;
  isEditMode: boolean;
}

export interface ITermsAndCondition{
  id:string,
  name:string,
  createdAt:string,

}

export interface CountryProfileInfo {
  countryName: string;
  twoDigitCountryCode: string;
  currencyCode: string;
  countryDigitCode: string;
  languageCode: string;
  region: string;
  countryCode: string;
  warehouseCountry: string;
  warehouseCity: string;
  warehouseState: string;
  warehouseStreet: string;
  warehouseZipCode: string;
  administrativeOriginName: string; 
  administrativeOriginState: string;
  administrativeOriginCountry: string;
  administrativeOriginCity: string;
  administrativeOriginStreet: string;
  administrativeOriginZipCode: string;
  partitionKey: string;
  id: string;
  companyCode: string;
  eTag: string;
  createdBy: string;
  vatId: string;
  isActive: string;
  bankName: string;
  bankAddress: string;
  addressLine1:string;
  addressLine2:string;
  addressLine3:string;
  accountName: string;
  accountNumber: string;
  iban: string;
  swiftCode: string;
  switchCode:string;
  swiftBicCode:string;
  correspondingBank: string;
  createdAt:string,
  updatedAt:string,
  termsAndConditions: ITermsAndCondition[],
  correspondingBankSwiftBICCode: string;
  sortCode:string;
  bankCompanyCode:string;
  bcCode:string;
  bsbCode:string;
  abn:string;
  bankKey:string;
  accountAddress:string;
  bankPhone: string;
  taxId: string;
  currency: string;
  updatedBy: string;
  remittanceCurrencyCode:string;
  remittanceCompanyCode:string;
  dateFormat?: string;
}


export type CountryProfileInfoType = {
  countryProfileInfo: CountryProfileInfo;
  setCountryProfileInfo: (countryProfileInfo: CountryProfileInfo) => void;
};

export interface CountryProfileLocationState {
  isCountryProfileFlow?: boolean;
}

export interface IResponseMessage {
  message: string;
  showMessage: boolean;
}

export const iconClass = mergeStyles({
  fontSize: 28,
  height: 28,
  width: 28,
  margin: "0 4px",
});
export const classNames = mergeStyleSets({
  deepSkyBlue: [{ color: "gery" }, iconClass],
});

 export const stackTokensWithGap10: Partial<IStackTokens> = { childrenGap: 10 };

export const getBreadcrumbItems = () => {
  const items: IBreadcrumbItem[] = [
    { text: "Country", key: "Country" ,href: '/#CountryProfile' },
    { text: "Create Country", key: "Create Country" ,  },
  ];
  return items;
};

export const countryComboBoxStyles: Partial<IComboBoxStyles> = {
  root: {
    width: 290,
  },
  callout: { width: "300px", height: "290px" },
  
};

export const textFieldGray: Partial<ITextFieldStyles> = {
  field: {
    backgroundColor: "#EDEBE9",
  },
  fieldGroup: {
    width: "290px",
  },
};

export const TextFieldStyles = {
  fieldGroup: {
    width: "290px",
  },
};

export const SubmitButtonStyle = {
  marginTop: "20px",
  paddding: "10px",
  marginBottom: "20px",
};
